import { observer } from 'mobx-react-lite'
import type { FC, PropsWithChildren } from 'react'
import { Typography } from 'shared/ui'
import { LINK_COMPLIANCE_LEARN_MORE_LINK, LINK_FAILED_MESSAGES } from 'shared/constants/links'
import { TrialTenLimitConversationsTooltip } from 'entities/Subscription/ui/TrialTenLimitConversationsTooltip'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CompliancePath } from 'entities/ExportRouters'
import styles from 'widgets/MessageCard/ui/DateContent/styles.module.scss'
import { type MessageProps } from 'widgets/MessageCard/ui/types'

export const FailedReasonContent = observer(({ message }: { message: MessageProps['message'] }) => {
  const { usersStore, tenDlcLimitsStore } = useEntitiesContext()
  const { failed_reason, isFailedTrial } = message

  const { user } = usersStore
  const isAdminOrOwnerRole = user?.isAdminOrOwnerRole
  const failedReason = failed_reason?.split('Learn more')[0]

  const learnMoreContent = (
    <Typography variant={'body-md-medium'} ariaLabel={'LearnMore'} linkLight>
      Learn more
    </Typography>
  )

  if (isFailedTrial) {
    return <TrialTenLimitConversationsTooltip />
  }
  if (
    tenDlcLimitsStore.isMessagingCanadaOnly &&
    failed_reason?.includes('10DLC unregistered number')
  ) {
    return (
      <>
        <FailedReasonWrap>
          {isAdminOrOwnerRole ? (
            <>
              <a
                href={`/${CompliancePath.compliance.businessProfile.root}`}
                target={'_blank'}
                rel='noreferrer'
              >
                <Typography variant={'body-sm-medium'} ariaLabel={'10DLC'} linkLight>
                  10DLC registration
                </Typography>
              </a>
            </>
          ) : (
            '10DLC registration'
          )}{' '}
          required. To send messages to USA contacts, your business must complete 10DLC
          registration.
        </FailedReasonWrap>
        <br />
        <a href={LINK_COMPLIANCE_LEARN_MORE_LINK} target={'_blank'} rel='noreferrer'>
          {learnMoreContent}
        </a>
      </>
    )
  }

  return (
    <>
      <FailedReasonWrap>{failedReason || ''}</FailedReasonWrap>
      <br />
      <a href={LINK_FAILED_MESSAGES} target={'_blank'} rel='noreferrer'>
        {learnMoreContent}
      </a>
    </>
  )
})

const FailedReasonWrap: FC<PropsWithChildren> = ({ children }) => (
  <Typography
    className={styles.wordBreakNormal}
    variant={'body-sm-regular'}
    color={'var(--content-primary-tertiary-inverted)'}
    ariaLabel={'FailedReason'}
    tag={'span'}
  >
    {children}
  </Typography>
)
